module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBmaWxsLW9wYWNpdHk9Ii4yIiByeD0iNCIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNSAxMykiPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxLjUiIGN5PSIxLjUiIHI9IjEuNSIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSI3LjUiIGN5PSIxLjUiIHI9IjEuNSIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxMy41IiBjeT0iMS41IiByPSIxLjUiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/dot_task.svg
// module id = HA5Q
// module chunks = 30